import * as Sentry from '@sentry/react';

export const configureSentry = () => {
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      tracesSampleRate: 0.1,
    });
  }
};
